import { createEntitySelectorHook } from "../../utils/createEntitySelectorHook";
import { popoverSelectors } from "../selectors";
import { TAppPopover, TPopoverIds } from "../types";

export const usePopoverSelectors: (id: TPopoverIds) => TAppPopover =
  createEntitySelectorHook(popoverSelectors);
